import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase/firebase";

export async function loadSavedMeasurements(customerId) {
  if (!customerId) return [];
  const snapshot = await getDocs(collection(db, "customers", customerId, "saved_measurements"));
  return snapshot.docs.map((document) => ({ id: document.id, ...document.data() }))
    .sort((a, b) => String(a.name || "").localeCompare(String(b.name || "")));
}
